/** Canvas-specific query params. Independent of `QueryParamNames` so canvas state is self-contained. */
export enum CanvasQueryParams {
  canvasId = 'cnId',
  canvasFullscreen = 'cnFs',
}

/** Returns only the canvas query params (cnId, cnFs) from the current URL. */
export const getCanvasQueryParams = (): Record<string, string> => {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const result: Record<string, string> = {};
  const cnId = params.get(CanvasQueryParams.canvasId);
  const cnFs = params.get(CanvasQueryParams.canvasFullscreen);

  if (cnId) {
    result[CanvasQueryParams.canvasId] = cnId;
  }
  if (cnFs) {
    result[CanvasQueryParams.canvasFullscreen] = cnFs;
  }

  return result;
};
